import React from 'react';
import Navigation from '../Common/Navigation';
import { NavLink } from 'react-router-dom';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';
import { submitFormSubmission } from '../../services/formSubmissionsApi';

var bnr = require('./../../images/background/bg-map.png');
var defaultLogo = require('./../../images/LogoYatay.png');

class Header extends React.Component {
    static contextType = SiteContentContext;

    constructor(props) {
        super(props);
        this.state = {
            logo: defaultLogo,
            isSearchActive: false,
            isQuoteActive: false,
            popupForm: {
                username: '',
                email: '',
                phone: '',
                message: '',
            },
            isPopupSubmitting: false,
            popupSubmitError: '',
            popupSubmitSuccess: '',
        };
        this.handleScroll = null;
    }

    handleSearchToggle = () => {
        this.setState((prev) => ({ isSearchActive: !prev.isSearchActive }));
    };

    handleQuoteToggle = () => {
        this.setState((prev) => ({ isQuoteActive: !prev.isQuoteActive }));
    };

    handlePopupFormChange = (event) => {
        const { name, value } = event.target;
        this.setState((prev) => ({
            ...prev,
            popupForm: {
                ...prev.popupForm,
                [name]: value,
            },
        }));
    };

    handlePopupFormSubmit = async (event) => {
        event.preventDefault();
        const { popupForm, isPopupSubmitting } = this.state;

        if (isPopupSubmitting) {
            return;
        }

        this.setState({ isPopupSubmitting: true, popupSubmitError: '', popupSubmitSuccess: '' });

        try {
            await submitFormSubmission({
                source: 'header-popup',
                page: window?.location?.pathname || '',
                name: popupForm.username,
                email: popupForm.email,
                phone: popupForm.phone,
                message: popupForm.message,
            });

            this.setState({
                isPopupSubmitting: false,
                popupSubmitError: '',
                popupSubmitSuccess: 'Mesajınız alındı. En kısa sürede dönüş yapacağız.',
                popupForm: {
                    username: '',
                    email: '',
                    phone: '',
                    message: '',
                },
            });
        } catch (error) {
            this.setState({
                isPopupSubmitting: false,
                popupSubmitSuccess: '',
                popupSubmitError: error?.message || 'Gönderim sırasında bir hata oluştu.',
            });
        }
    };

    componentDidMount() {
        this.handleScroll = () => {
            const offset = window.scrollY;
            const stickyheader = document.querySelector('.sticky-header ');

            if (!stickyheader) {
                return;
            }

            if (offset >= 100) {
                stickyheader.classList.add('is-fixed');
                stickyheader.classList.add('color-fill');
            } else {
                stickyheader.classList.remove('is-fixed');
                stickyheader.classList.remove('color-fill');
            }
        };

        window.addEventListener('scroll', this.handleScroll);

        window.updateTopMostParent = (logopath) => {
            this.setState({ logo: logopath });
        };
    }

    componentWillUnmount() {
        if (this.handleScroll) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }

    renderLineBreakList(items) {
        return (items || []).map((item, index) => (
            <React.Fragment key={`${item}-${index}`}>
                {item}
                {index < items.length - 1 ? <br /> : null}
            </React.Fragment>
        ));
    }

    render() {
        const { isSearchActive, isQuoteActive, popupForm, isPopupSubmitting, popupSubmitError, popupSubmitSuccess } = this.state;
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const contact = getByPath(content, 'contact', {});
        const social = getByPath(content, 'social', {});
        const phones = Array.isArray(contact.phones) ? contact.phones : [];
        const addressLines = Array.isArray(contact.addressLines) ? contact.addressLines : [];
        const logoSrc = resolveMediaSrc(getByPath(content, 'media.logoUrl', ''), this.state.logo);

        const headerText = t?.header || {};
        const popupText = headerText.popup || {};
        const popupFormText = headerText.form || {};

        return (
            <>
                <header className="site-header header-style-1 nav-wide mobile-sider-drawer-menu">
                    <div className="top-bar bg-gray">
                        <div className="container">
                            <div className="d-flex justify-content-end">
                                <ul className="list-unstyled e-p-bx">
                                    <li><span>{headerText.topBarEmailLabel || 'Bize Yazın:'}</span> {contact.email}</li>
                                    <li><span>{headerText.topBarPhoneLabel || 'Bizi Arayın:'}</span> {phones[0] || ''}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="sticky-header main-bar-wraper navbar-expand-lg">
                        <div className="main-bar header-left-gray-block bg-white">
                            <div className="container clearfix">
                                <div className="logo-header">
                                    <div className="logo-header-inner logo-header-one">
                                        <NavLink to={'/'}>
                                            <img src={logoSrc} alt="Fırat Çelik Kapı" style={{ maxHeight: '80px', width: 'auto' }} />
                                        </NavLink>
                                    </div>
                                </div>

                                <button id="mobile-side-drawer" data-target=".header-nav" data-toggle="collapse" type="button" className="navbar-toggler collapsed">
                                    <span className="sr-only">Navigasyonu aç/kapa</span>
                                    <span className="icon-bar icon-bar-first" />
                                    <span className="icon-bar icon-bar-two" />
                                    <span className="icon-bar icon-bar-three" />
                                </button>

                                <div className="extra-nav">
                                    <div className="extra-cell">
                                        <NavLink to={'#'} onClick={this.handleSearchToggle}>
                                            <i className="fa fa-search" />
                                        </NavLink>
                                    </div>
                                    <div className="extra-cell">
                                        <div className="contact-slide-show">
                                            <NavLink to={'#'} className="get-in-touch-btn from-top" onClick={this.handleQuoteToggle}>
                                                {headerText.contactPopupButton || 'İletişime Geçin'}
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>

                                <div className="header-nav nav-dark navbar-collapse collapse justify-content-start collapse">
                                    <Navigation />
                                </div>

                                <div className="contact-slide-hide" style={{ backgroundImage: 'url(' + bnr + ')', right: isQuoteActive ? '0px' : '100%' }}>
                                    <div className="contact-nav">
                                        <NavLink to={'#'} className="contact_close" onClick={this.handleQuoteToggle}>×</NavLink>
                                        <div className="contact-nav-form">
                                            <div className="row">
                                                <div className="col-xl-5 col-lg-5 col-md-12 contact-nav-form-col-info">
                                                    <div className="contact-nav-info">
                                                        <div className="sx-icon-box-wraper left p-b30">
                                                            <div className="icon-xs inline-icon m-b20 scale-in-center"><i className="fa fa-phone" /></div>
                                                            <div className="icon-content">
                                                                <h6 className="m-t0">{popupText.phoneTitle || 'Telefon Numarası'}</h6>
                                                                <p>{this.renderLineBreakList(phones)}</p>
                                                            </div>
                                                        </div>
                                                        <div className="sx-icon-box-wraper left p-b30">
                                                            <div className="icon-xs inline-icon m-b20 scale-in-center"><i className="fa fa-envelope" /></div>
                                                            <div className="icon-content">
                                                                <h6 className="m-t0">{popupText.emailTitle || 'E-posta Adresi'}</h6>
                                                                <p>{contact.email}</p>
                                                            </div>
                                                        </div>
                                                        <div className="sx-icon-box-wraper left p-b30">
                                                            <div className="icon-xs inline-icon m-b20 scale-in-center"><i className="fa fa-map-marker" /></div>
                                                            <div className="icon-content">
                                                                <h6 className="m-t0">{popupText.addressTitle || 'Adres Bilgisi'}</h6>
                                                                <p>{this.renderLineBreakList(addressLines)}</p>
                                                            </div>
                                                        </div>
                                                        <div className="sx-icon-box-wraper left p-b30">
                                                            <div className="icon-xs inline-icon m-b20 scale-in-center"><i className="fa fa-clock-o" /></div>
                                                            <div className="icon-content">
                                                                <h6 className="m-t0">{popupText.workingHoursTitle || 'Çalışma Saatleri'}</h6>
                                                                <p>{contact?.workingHours?.weekdays}<br />{contact?.workingHours?.sunday}</p>
                                                            </div>
                                                        </div>
                                                        <div className="full-social-bg">
                                                            <ul>
                                                                <li><a href={social.facebook || 'https://www.facebook.com'} target="_blank" rel="noreferrer"><i className="fa fa-facebook" /></a></li>
                                                                <li><a href={social.instagram || 'https://www.instagram.com'} target="_blank" rel="noreferrer"><i className="fa fa-instagram" /></a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-7 col-lg-7 col-md-12 contact-nav-form-col-form">
                                                    <div className="contact-nav-field shadow-lg p-a30 bg-white" style={{ backgroundImage: 'url(' + bnr + ')' }}>
                                                        <form className="cons-contact-form2 form-transparent" method="post" action="#" onSubmit={this.handlePopupFormSubmit}>
                                                            <div className="input input-animate">
                                                                <label htmlFor="name">{popupFormText.nameLabel || 'İsim'}</label>
                                                                <input type="text" name="username" id="name" required value={popupForm.username} onChange={this.handlePopupFormChange} />
                                                                <span className="spin" />
                                                            </div>
                                                            <div className="input input-animate">
                                                                <label htmlFor="email">{popupFormText.emailLabel || 'E-posta'}</label>
                                                                <input type="email" name="email" id="email" required value={popupForm.email} onChange={this.handlePopupFormChange} />
                                                                <span className="spin" />
                                                            </div>
                                                            <div className="input input-animate">
                                                                <label htmlFor="Phone">{popupFormText.phoneLabel || 'Telefon'}</label>
                                                                <input type="text" name="phone" id="Phone" required value={popupForm.phone} onChange={this.handlePopupFormChange} />
                                                                <span className="spin" />
                                                            </div>
                                                            <div className="input input-animate">
                                                                <label htmlFor="message">{popupFormText.messageLabel || 'Mesajınız'}</label>
                                                                <textarea name="message" id="message" required value={popupForm.message} onChange={this.handlePopupFormChange} />
                                                                <span className="spin" />
                                                            </div>
                                                            <div className="text-left p-t10">
                                                                <button type="submit" className="site-button-secondry btn-half " disabled={isPopupSubmitting}>
                                                                    <span>{isPopupSubmitting ? 'Gönderiliyor...' : (popupFormText.submitLabel || 'Gönder')}</span>
                                                                </button>
                                                            </div>
                                                            {popupSubmitSuccess ? <p className="m-t10" style={{ color: '#2f8f2f' }}>{popupSubmitSuccess}</p> : null}
                                                            {popupSubmitError ? <p className="m-t10" style={{ color: '#c9302c' }}>{popupSubmitError}</p> : null}
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="search" className={isSearchActive ? 'open' : null}>
                                    <span className="close" onClick={this.handleSearchToggle} />
                                    <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
                                        <div className="input-group">
                                            <input defaultValue="" name="q" type="search" placeholder={headerText.searchPlaceholder || 'Aramak için yazın'} />
                                            <span className="input-group-btn"><button type="button" className="search-btn"><i className="fa fa-search arrow-animation" /></button></span>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </>
        );
    };
};

export default Header;
